export enum ENotificationAction {
  RELOAD = 'notification.action.reload',
  SELECT_ANOTHER_TOOL = 'notification.action.select_another_tool',
}
